import SupplyChainBudgetCard from '../shopping/SupplyChainBudgetCard'
import type { GroceryItem } from '../../lib/protocolTypes'
import type { NearbyStore } from '../../lib/storeTypes'

type ShoppingTabProps = {
  items: GroceryItem[]
  nearbyStores?: NearbyStore[]
  isPremium?: boolean
  preferredCurrency?: string
  currencySymbol?: string
  countryCode?: string
  currencyCode?: string
  onItemUpdated?: () => void
}

const ShoppingTab = ({
  items,
  nearbyStores,
  isPremium,
  preferredCurrency,
  currencySymbol,
  countryCode,
  currencyCode,
  onItemUpdated,
}: ShoppingTabProps) => (
  <SupplyChainBudgetCard
    items={items}
    nearbyStores={nearbyStores}
    isPremium={isPremium}
    preferredCurrency={preferredCurrency}
    currencySymbol={currencySymbol}
    countryCode={countryCode}
    currencyCode={currencyCode}
    onItemUpdated={onItemUpdated}
  />
)

export default ShoppingTab
